import { useCitiesListSuspense as useCitiesList } from "architecture/src/shared/api/endpoints/cities/cities";

export const useProfileCity = (cityId?: number) => {
  return useCitiesList({
    query: {
      select: (cities) => cities.find(({ id }) => id === cityId),
    },
  });
};
